import React from 'react';
import { Header, Segment, Grid, Divider, Icon } from 'semantic-ui-react';
import { DestinatarioMatricola, Matricola } from '../models';
import parse from 'html-react-parser';

type MatricoleDestinatariMobileProps = {
    elemento: DestinatarioMatricola,
    active: string,
    onSelectMatricola: (matricola: Matricola) => void
}

export default class DestinatarioMatricoleMobile extends React.Component<MatricoleDestinatariMobileProps> {

    render() {
        const { elemento, onSelectMatricola, active } = this.props;
        const tertiary = active === elemento.idDestinatario;
        const secondary = !tertiary;
        const color = active === elemento.idDestinatario ? 'green' : undefined;
        return (
            <>
                <Segment attached='bottom' color={color} tertiary={tertiary} secondary={secondary}>
                    <Header>{elemento.destinatario}</Header>
                </Segment>
                <Divider hidden />
                <Grid centered divided='vertically'>
                    {elemento.matricole.map(matricola=>{
                        return (
                            <React.Fragment key={matricola.idSpecifica}>
                                <Grid.Row onClick={() => onSelectMatricola(matricola)}>
                                    <Grid.Column width='16'>
                                        <Grid>
                                            <Grid.Row verticalAlign='middle' style={{ padding: 3 }}>
                                                <Grid.Column width='4'><b>{matricola.numeroMacchina}</b></Grid.Column>
                                                <Grid.Column width='5'>{matricola.codice}</Grid.Column>
                                                <Grid.Column width='7' textAlign='right'>{matricola.descrizione}</Grid.Column>
                                            </Grid.Row>
                                            {
                                                matricola.ubicazione !== "" &&
                                                <Grid.Row verticalAlign='middle' style={{ padding: 3 }}>
                                                    <Grid.Column width='2'><Icon color='green' name='map marker alternate'/></Grid.Column>
                                                    <Grid.Column width='14' verticalAlign='middle'> {parse(matricola.ubicazione)}</Grid.Column>
                                                </Grid.Row>
                                            }
                                        </Grid>
                                    </Grid.Column>
                                </Grid.Row>
                            </React.Fragment>
                        )
                    })}
                </Grid>
                <Divider hidden />
            </>
        );
    }
}